import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Collapsed",
  "use": "Collapsed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Collapsed\"><rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#F4F5F7\" /><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\" /><path d=\"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-4-7.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1Z\" fill=\"#1976D2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol